module.exports = __webpack_public_path__ + "img/special-forces.2ed2fa81.jpg";